import { FC, useState } from "react";
import KickImage from 'Reuseables/KickImage';

//Components
import Component from "./Component";

//Cancel pickup request
import { cancelPickupRequest } from "../../../../actions/shipperAction";

//Helpers
import { printError } from "../../../../utils/Helpers";

type Props = {
  order_id?: string;
  onBack: (args?: string) => void;
  requestCancelled: () => void;
}
const Wrapper: FC<Props> = ({
  order_id,
  onBack,
  requestCancelled
}) => {
  const [selected, setSelected] = useState<string>("")
  const [loading, setLoading] = useState(false);
  const [toastMessage, setToastMessage] = useState("")

  const resetToastMessage = () => setToastMessage("");

  const cancelPickupHandler = async () => {
    try {
      setLoading(true)
      await cancelPickupRequest(order_id, { reason: selected })
        .then(res => {
          requestCancelled()
        })
        .catch(err => { throw err })
        .finally(() => {
          setLoading(false)
        })
    } catch (err) {
      const errMsg = printError(err);
      setLoading(false)
      setToastMessage("Cannot cancel the order, please try again later")
      console.log(err, "Err when cancel pickup fn cancelPickupHandler file Request cancel Pickup")
    }
  }

  return (
    <Component
      loading={loading}
      selected={selected}
      toastMessage={toastMessage}
      resetToastMessage={resetToastMessage}
      onBack={onBack}
      setSelected={setSelected}
      cancelPickupHandler={cancelPickupHandler}
    />
  )
}

export default Wrapper;